//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import numeric from "@/components/numeric";
import lazyLoadSelect from "@/components/LazyLoadSelect";
import logger from "@/utils/logger";

export default {
  props: {
    article: {},
  },
  components: {
    numeric,
    lazyLoadSelect
  },
  data() {
    return {
      productTypes: [
        { value: 0, label: this.$t("products.notSelected") },
        { value: 1, label: this.$t("products.stockProduct") },
        { value: 2, label: this.$t("products.timeProduct") },
        { value: 4, label: this.$t("products.orderingProduct") },
        { value: 3, label: this.$t("products.somethingElse") },
      ],
      Products: [],
      Countries: [],
      FilterCountry: [],
      dense: true,
    };
  },
  computed: {},
  methods: {
    ...mapActions("main", ["getReferencesProducts", "getCountries", "getProduct"]),

    async fetchProducts({ pageNumber, pageSize, searchQuery }) {
            try {
                const result = await this.getReferencesProducts({
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'ProductNumber',
                    sortDescending: false
                })
                return result
            } catch (error) {
                console.error('Error fetching products:', error)
                return { items: [], totalPages: 1 }
            }
        },

      async fetchProduct(productId) {
          try {
              const result = await this.getProduct(productId)
              logger.log({result})
              return result
          } catch (error) {
              console.error('Error fetching product:', error)
              return null;
          }
      },

      productLabel(product) {
          if (!product) return ''
          return `${product.productNumber}: ${product.productName}`
      },

    async getAllCountries() {
      this.Countries = await this.getCountries();      
      this.FilterCountry = this.Countries;      
    },

    filterCountry(val, update){
      if (!this.Countries) {
        update();
        return;
      }
      update(() => {
        this.Countries = this.FilterCountry.filter(
          (p) => p.countryCode.toLowerCase().indexOf(val.toLowerCase()) > -1 ||  p.name.toLowerCase().indexOf(val.toLowerCase()) > -1 
        );
      });
    },

  },

  created() {
    this.getAllCountries();
  },

  mounted(){
    this.articleType = this.article.type;
  },


  watch: {  
    'article.type': function (newValue, oldValue){
      if (newValue != oldValue) {
        if (newValue != 0) {
      
          this.article.mainComponent = false;          
        }         
        this.article.type = newValue;        
      }
     },
  },

};
